import { RootState } from "../../../redux-store";

export const selectIsOutdated = (state: RootState) =>
  state.app.version.outdated;
